import type { GameSettings, GameState, PlayerProfile, SaveData } from "../types";

export const defaultSettings: GameSettings = {
  masterVolume: 0.75,
  bgmVolume: 0.35,
  sfxVolume: 0.75,
  uiScale: 1,
  textSpeed: "normal",
  reducedFlash: false,
  highContrast: false
};

export const defaultProfile: PlayerProfile = {
  totalRuns: 0,
  totalMistakes: 0,
  endings: [],
  discoveredAnomalyIds: []
};

function createRunId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `run-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function createInitialGameState(seed = Date.now() >>> 0): GameState {
  const now = new Date().toISOString();
  return {
    runId: createRunId(),
    seed,
    rngStep: 0,
    phase: "tutorial",
    progress: 0,
    requiredProgress: 8,
    loopCount: 0,
    mistakeCount: 0,
    correctCount: 0,
    discoveredAnomalyIds: [],
    currentMail: null,
    currentMailIndex: 0,
    seenMailIds: [],
    seenVariantIds: [],
    usedAnomalyIds: [],
    anomalyUseCounts: {},
    triggeredStoryEventIds: [],
    portalMutationIds: [],
    manualMutationIds: [],
    directoryMutationIds: [],
    flags: {},
    history: [],
    startedAt: now,
    lastUpdatedAt: now
  };
}

export function createDefaultSave(): SaveData {
  return {
    version: 1,
    settings: { ...defaultSettings },
    profile: { ...defaultProfile }
  };
}
